export * from './OverflowingTextTip';
